import React, { useEffect, useState } from "react";
import {
  getEntranceDoorsGridImages,
  getEntranceDoorsImages,
} from "../../services/image_services";
import colors from "../../styles/colors";
import LoadingImage from "../../components/LoadingImage";
import ProductMain from "../../components/ProductMain";
import Description from "../../components/Description";
import AccessoryContainer from "../../components/AccessoryContainer";
import ImageGridBox from "../../components/ImageGridBox";
import { useTranslation } from "react-i18next";
import SEO from "../../utils/SEO";

const EntranceDoors: React.FC = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState<string[]>([]);
  const [gridImages, setGridImages] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      setIsLoading(true);

      try {
        const urls = await getEntranceDoorsImages(); // Lokális képlekérdezés
        const gridUrls = await getEntranceDoorsGridImages(); // Grid képek lekérdezése
        setImages(urls);
        setGridImages(gridUrls);
      } catch (error) {
        console.error("Hiba a bejárati ajtók képek betöltésekor:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center font-serif min-h-screen overflow-hidden"
      style={{ backgroundColor: colors.pastelCream }}
    >
      {/* SEO meta tags */}
      <SEO
        title={t("seo_meta.entrance_doors.metaTitle")}
        description={t("seo_meta.entrance_doors.metaDescription")}
      />

      {isLoading ? (
        <div className="w-full h-screen flex items-center justify-center">
          <LoadingImage />
        </div>
      ) : (
        <>
          <ProductMain
            image="/assets/images/products/ext_doors/entr_main.webp"
            title={t("entr_doors.title")}
            description={t("entr_doors.subTitle")}
          />

          {/* General description */}
          <Description
            image={images[0]}
            title={t("entr_doors.descTitle1")}
            text={t("entr_doors.desc1")}
            imageOnRight={false}
            isFirst={true}
          />

          {/* Wooden entrance doors */}
          <Description
            image={images[1]}
            title={t("entr_doors.descTitle2")}
            text={t("entr_doors.desc2")}
            imageOnRight={true}
          />

          {/* Grid with a description above it */}
          <div
            className="mt-12 w-full py-8"
            style={{ backgroundColor: colors.black, color: colors.lightCream }}
          >
            <h3
              className="text-center p-4 lg:text-2xl text-lg md:text-xl font-light mb-4 sm:mb-6 mt-4 sm:mt-6"
              style={{ color: colors.lightCream }}
            >
              {t("int_doors.galleryText")}
            </h3>

            <div className="container mx-auto px-4">
              <ImageGridBox
                images={gridImages}
                thumbnailLayout="grid grid-cols-2 md:grid-cols-4 gap-4"
                thumbnailImageSize="h-auto max-w-full rounded-lg"
              />
            </div>
            {/* Horizontal Divider */}
            <div
              className="w-full max-h-[10] pt-4 pb-4 flex justify-center"
              style={{ backgroundColor: colors.black }}
            >
              <hr
                className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
                style={{ backgroundColor: colors.lightCream }}
              />
            </div>
          </div>

          {/* Window Accessories Container */}
          <AccessoryContainer />
        </>
      )}
    </div>
  );
};

export default EntranceDoors;
